export default {
    data() {
        return {
            dragItemIndex: -1,
            hoverItemIndex: -1,
            isDragging: false,
            isDragOver: false,
            cloneNode: null,
        };
    },
    methods: {
        handleDragStart(e) {
            const cloneNode = e.target.cloneNode(true);
            const thumbnailImg = cloneNode.querySelector('.content--info_image');
            thumbnailImg.src = e.target.__vue__.thumbnailDataUrl;
            cloneNode.style.position = 'absolute';
            cloneNode.style.top = '-150px';
            cloneNode.style.width = `${e.target.clientWidth}px`;
            cloneNode.style.backgroundColor = 'rgba(255,255,255,1)';
            cloneNode.style.cursor = 'grabbing !important';
            cloneNode.style.pointerEvents = 'none';
            document.body.appendChild(cloneNode);

            e.dataTransfer.effectAllowed = 'uninitialized';
            e.dataTransfer.setData('text/plain', e.target.dataset.index);
            e.dataTransfer.setDragImage(cloneNode, e.layerX, e.layerY);


            this.cloneNode = cloneNode;
            this.isDragging = true;
            this.dragItemIndex = Number(e.target.dataset.index);
        },
        handleDragEnd(e) {
            this.isDragging = false;
            this.isDragOver = false;
            this.dragItemIndex = -1;
            this.hoverItemIndex = -1;

            document.body.removeChild(this.cloneNode);
            this.cloneNode = null;
            // console.log('handleDragEnd');
        },
        handleDragEnter(e) {
            e.preventDefault();
            this.hoverItemIndex = Number(e.target.dataset.index);
            // console.log('handleDragEnter');
        },
        handleDragLeave(e) {
            this.hoverItemIndex = -1;
            // console.log('handleDragLeave');
        },
        handleDragOver(e) {
            this.isDragOver = true;
        },
        handleDragDrop(e, callback) {
            e.dataTransfer.dropEffect = 'move';
            const movingTarget = e.dataTransfer.getData('text/plain'); // 1
            callback(movingTarget);
        },
    },
};
